import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';

export const Title = styled.div`
  font-size: 18px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
  text-align: center;
`;

export const SubTitle = styled.div`
  color: ${COLORS.textGrey};
  text-align: center;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

export const InCompleteTransactionModalContainer = styled.div`
  width: 450px;
  padding: 32px 24px;
  display: flex;
  margin: 14px;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  gap: 24px;
  background-color: ${COLORS.white};
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;
